const UserLoginRequest = {
  id: '',
  dateOfBirth: ''
}

export {UserLoginRequest};